// @flow
import { NOT_FRIEND } from '../constants/friendStatusTypes';

function decodeEmailUser(email: string) {
  return {
    id: email,
    username: email,
    avatar: null,
    status: NOT_FRIEND,
    sortOrder: 4
  };
}

export default decodeEmailUser;
